import React, { useState } from 'react';
import { Modal, Button, Form, Container, Row, Col } from 'react-bootstrap';
import statesWithDistricts from '../../../data/data'; 
import { useDispatch } from 'react-redux';
import { createSchool } from '../../../store/actions/schoolActions';
import Swal from 'sweetalert2';
import Spinner from 'react-bootstrap/Spinner';
import './spinner.css';

const CreateProfileModal = ({ showModal, handleClose }) => {

    const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  
  const [schoolDetails, setSchoolDetails] = useState({
    school_name: '',
    school_address: '',
    city: '',
    state: '',
    district: '',
    postal_code: '',
    country: 'India',
    contact_number: '',
    email_address: '',
    website_url: '',
    established_year: '',
    principal_name: '',
    principal_image: null,
    director_name: null,
    director_image: null,
    head_teacher_name: null,
    head_teacher_image: null,
    head_title: '',
    principal_title: '',
    dir_title: '',
});


  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setSchoolDetails((prev) => ({
      ...prev,
      [name]: type === 'file' ? files[0] : value,
    }));
  };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true); // Start showing the spinner

        const formData = new FormData();
        for (const key in schoolDetails) {
            formData.append(key, schoolDetails[key]);
        }

        dispatch(createSchool(formData))
            .then(() => {
                // Simulate delay before showing SweetAlert
                setTimeout(() => {
                    setIsLoading(false); // Stop showing the spinner

                    // Show SweetAlert2 success message
                    Swal.fire({
                        icon: 'success',
                        title: 'School profile created',
                        text: 'The school profile has been created successfully!',
                    });

                    handleClose(); // Close modal after submission
                }, 1500); // Show the spinner for 1.5 seconds
            })
            .catch((error) => {
                // Simulate delay before showing error SweetAlert
                setTimeout(() => {
                    setIsLoading(false); // Stop showing the spinner

                    // Show SweetAlert2 error message
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to create the school profile. Please try again.',
                    });

                    console.error("Error creating school profile:", error);
                }, 1500);
            });
    };
    
  

  return (
    <>
    <Modal show={showModal} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>School Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="school_name" className="mb-3">
              <Form.Label className="form-label text-primary">School Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter school name"
                name="school_name"
                value={schoolDetails.school_name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="school_address" className="mb-3">
              <Form.Label className="form-label text-primary">Address</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter school_address"
                name="school_address"
                value={schoolDetails.school_address}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Row>
              <Col md={4}>
                <Form.Group controlId="city" className="mb-3">
                  <Form.Label className="form-label text-primary">City</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter city"
                    name="city"
                    value={schoolDetails.city}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={8}>
                <div className="mb-3">
                  <label className="form-label text-primary">
                    State & District <span className="required">*</span>
                  </label>
                  <div className="d-flex">
                    <Form.Select
                      size="lg"
                      style={{ width: '100%', backgroundColor: 'white', border:'1px solid' }}
                      name="state"
                      value={schoolDetails.state}
                      onChange={(e) => {
                        const selectedStateName = e.target.value;
                        setSchoolDetails((prev) => ({
                          ...prev,
                          state: selectedStateName,
                          district: '', // Reset district when state changes
                        }));
                      }}
                    >
                      <option value="">Select State</option>
                      {statesWithDistricts.map((state) => (
                        <option key={state.name} value={state.name}>
                          {state.name}
                        </option>
                      ))}
                    </Form.Select>
                    <span className='p-1'></span>
                    <Form.Select
                      size="lg"
                      style={{ width: '100%', backgroundColor: 'white', border:'1px solid' }}
                      name="district"
                      value={schoolDetails.district}
                      onChange={(e) => {
                        const selectedDistrictName = e.target.value;
                        setSchoolDetails((prev) => ({
                          ...prev,
                          district: selectedDistrictName,
                        }));
                      }}
                      disabled={!schoolDetails.state} // Disable if no state is selected
                    >
                      <option value="">Select District</option>
                      {statesWithDistricts
                        .find((state) => state.name === schoolDetails.state)
                        ?.districts.map((district) => (
                          <option key={district.name} value={district.name}>
                            {district.name}
                          </option>
                        ))}
                    </Form.Select>
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
                <Col md={4}>
                    <Form.Group controlId="postal_code" className="mb-3">
                        <Form.Label className="form-label text-primary">Pin Code</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter contact number"
                            name="postal_code"
                            value={schoolDetails.postal_code}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                </Col>
                <Col md={8}>
                    <Form.Group controlId="contact_number" className="mb-3">
                        <Form.Label className="form-label text-primary">Contact Number</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter contact number"
                            name="contact_number"
                            value={schoolDetails.contact_number}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                </Col>
            </Row>

            <Form.Group controlId="email_address" className="mb-3">
              <Form.Label className="form-label text-primary">Email</Form.Label>
              <Form.Control
                type="email_address"
                placeholder="Enter email_address"
                name="email_address"
                value={schoolDetails.email_address}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="website_url" className="mb-3">
              <Form.Label className="form-label text-primary">Website URL</Form.Label>
              <Form.Control
                type="url"
                placeholder="Enter website_url URL"
                name="website_url"
                value={schoolDetails.website_url}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="established_year" className="mb-3">
              <Form.Label className="form-label text-primary">Established Year</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter established year"
                name="established_year"
                value={schoolDetails.established_year}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="principal_name" className="mb-3">
            <Form.Label className="form-label text-primary">Principal Name</Form.Label>
              <Row>
                <Col xs={6} className="d-flex align-items-center">
                  {/* First column with flexed radio buttons */}
                  <div className="d-flex flex-wrap gap-2">
                    <Form.Check
                      type="radio"
                      label="Dr."
                      name="principal_title"
                      id="dr"
                      value="Dr."
                      onChange={handleChange}
                    />
                    <Form.Check
                      type="radio"
                      label="Mr."
                      name="principal_title"
                      id="mr"
                      value="Mr."
                      onChange={handleChange}
                    />
                    <Form.Check
                      type="radio"
                      label="Mrs."
                      name="principal_title"
                      id="mrs"
                      value="Mrs."
                      onChange={handleChange}
                    />
                    <Form.Check
                      type="radio"
                      label="Ms."
                      name="principal_title"
                      id="ms"
                      value="Ms."
                      onChange={handleChange}
                    />
                    <Form.Check
                      type="radio"
                      label="Miss"
                      name="principal_title"
                      id="miss"
                      value="Miss"
                      onChange={handleChange}
                    />
                  </div>
                </Col>
                <Col xs={6}>
                  {/* Second column with text input */}
                  <Form.Control
                    type="text"
                    placeholder="Enter principal name"
                    name="principal_name"
                    value={schoolDetails.principal_name}
                    onChange={handleChange}
                    required
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group controlId="principal_image" className="mb-3">
              <Form.Label className="form-label text-primary">Principal Image</Form.Label>
              <Form.Control
                type="file"
                name="principal_image"
                accept="image/*"
                onChange={handleChange}
              />
            </Form.Group>

            {/* <Form.Group controlId="director_name" className="mb-3">
              <Form.Label className="form-label text-primary">Director Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter director name"
                name="director_name"
                value={schoolDetails.director_name}
                onChange={handleChange}
                required
              />
            </Form.Group> */}
            <Form.Group controlId="director_name" className="mb-3">
            <Form.Label className="form-label text-primary">Director Name</Form.Label>
              <Row>
                <Col xs={6} className="d-flex align-items-center">
                  {/* First column with flexed radio buttons */}
                  <div className="d-flex flex-wrap gap-2">
                    <Form.Check
                      type="radio"
                      label="Dr."
                      name="dir_title"
                      id="dr"
                      value="Dr."
                      onChange={handleChange}
                    />
                    <Form.Check
                      type="radio"
                      label="Mr."
                      name="dir_title"
                      id="mr"
                      value="Mr."
                      onChange={handleChange}
                    />
                    <Form.Check
                      type="radio"
                      label="Mrs."
                      name="dir_title"
                      id="mrs"
                      value="Mrs."
                      onChange={handleChange}
                    />
                    <Form.Check
                      type="radio"
                      label="Ms."
                      name="dir_title"
                      id="ms"
                      value="Ms."
                      onChange={handleChange}
                    />
                    <Form.Check
                      type="radio"
                      label="Miss"
                      name="dir_title"
                      id="miss"
                      value="Miss"
                      onChange={handleChange}
                    />
                  </div>
                </Col>
                <Col xs={6}>
                  {/* Second column with text input */}
                  <Form.Control
                    type="text"
                    placeholder="Enter director name"
                    name="director_name"
                    value={schoolDetails.director_name}
                    onChange={handleChange}
                    required
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group controlId="director_image" className="mb-3">
              <Form.Label className="form-label text-primary">Director Image</Form.Label>
              <Form.Control
                type="file"
                name="director_image"
                accept="image/*"
                onChange={handleChange}
              />
            </Form.Group>

            
            <Form.Group controlId="head_teacher_name" className="mb-3">
              <Form.Label className="form-label text-primary">Head Teacher Name</Form.Label>
              <Row>
                <Col xs={6} className="d-flex align-items-center">
                  {/* First column with flexed radio buttons */}
                  <div className="d-flex flex-wrap gap-2">
                    <Form.Check
                      type="radio"
                      label="Dr."
                      name="head_title"
                      id="dr"
                      value="Dr."
                      onChange={handleChange}
                    />
                    <Form.Check
                      type="radio"
                      label="Mr."
                      name="head_title"
                      id="mr"
                      value="Mr."
                      onChange={handleChange}
                    />
                    <Form.Check
                      type="radio"
                      label="Mrs."
                      name="head_title"
                      id="mrs"
                      value="Mrs."
                      onChange={handleChange}
                    />
                    <Form.Check
                      type="radio"
                      label="Ms."
                      name="head_title"
                      id="ms"
                      value="Ms."
                      onChange={handleChange}
                    />
                    <Form.Check
                      type="radio"
                      label="Miss"
                      name="head_title"
                      id="miss"
                      value="Miss"
                      onChange={handleChange}
                    />
                  </div>
                </Col>
                <Col xs={6}>
                  {/* Second column with text input */}
                  <Form.Control
                    type="text"
                    placeholder="Enter head teacher name"
                    name="head_teacher_name"
                    value={schoolDetails.head_teacher_name}
                    onChange={handleChange}
                    required
                  />
                </Col>
              </Row>
            </Form.Group>


            <Form.Group controlId="head_teacher_image" className="mb-3">
              <Form.Label className="form-label text-primary">Head Teacher Image</Form.Label>
              <Form.Control
                type="file"
                name="head_teacher_image"
                accept="image/*"
                onChange={handleChange}
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100">
              Create School Profile
            </Button>

          </Form>
        </Container>
      </Modal.Body>
    </Modal>

    {/* // Spinner  */}
    {isLoading && (
        <div className="spinner-container">
            <Spinner animation="border" role="status">
                <span className="sr-only">Submitting Detail...</span>
            </Spinner>
        </div>
    )}
    </>
  );
};

export default CreateProfileModal;
